var React = require('react');

function XStraight (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"-1","x2":"33.71","y2":"-1","transform":"matrix(0.702226 0.711954 -0.702226 0.711954 2 2)","strokeWidth":"2","key":0}),React.createElement("line",{"y1":"-1","x2":"33.71","y2":"-1","transform":"matrix(0.702226 -0.711954 0.702226 0.711954 2.32812 26)","strokeWidth":"2","key":1})]);
}

XStraight.defaultProps = {"width":"28","height":"26","viewBox":"0 0 28 26"};

module.exports = XStraight;

XStraight.default = XStraight;
